// extracted by mini-css-extract-plugin
export default {"wrapper":"Authentication_wrapper__wCsAn"};